// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation JSON files
import ArTranslation from './locales/ar.json';
import EnTranslation from './locales/en.json';

const resources = {
  ar: { translation: ArTranslation },
  en: { translation: EnTranslation }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    keySeparator: false, // if you don't use keys in nested objects
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
